var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewspaperIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    viewBox: "0 0 73 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05969 9.99316H12.3404V13.2705H9.05969V9.99316Z",
    fill: "black",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6216 9.99316H20.9023V13.2705H17.6216V9.99316Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.183 9.99316H29.4637V13.2705H26.183V9.99316Z",
    fill: "black",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 5.20874V4.70874H68.7227H4.27734H3.77734V5.20874V18.0547V18.5547H4.27734H68.7227H69.2227V18.0547V5.20874ZM4.27734 21.832H3.77734V22.332V60.5921V61.0921V61.0927H4.27734V61.5921H68.7227H69.2227V61.0921V22.332V21.832H68.7227H4.27734ZM0.5 64.8695V1.4314H72.5V64.8695H0.5Z",
    fill: "black",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9057 52.9164H58.4057V52.4164V48.1318V47.6318H57.9057H23.541H23.041V48.1318V52.4164V52.9164H23.541H57.9057ZM15.0944 47.6318H14.5944V48.1318V52.4164V52.9164H15.0944H19.2637H19.7637V52.4164V48.1318V47.6318H19.2637H15.0944ZM61.683 44.3545V56.1938H11.317V44.3545H61.683Z",
    fill: "black",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1403 35.7927H61.6846V39.0701H39.1403V35.7927Z",
    fill: "black",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3153 35.7927H33.8596V39.0701H11.3153V35.7927Z",
    fill: "black",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.158 27.231H48.8426V30.5083H24.158V27.231Z",
    fill: "black",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3153 27.231H18.8767V30.5083H11.3153V27.231Z",
    fill: "black",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1233 27.231H61.6847V30.5083H54.1233V27.231Z",
    fill: "black",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperIcon);
export default __webpack_public_path__ + "static/media/newspaperIcon.1e2eda36f42937a56c6f6ba842252140.svg";
export { ForwardRef as ReactComponent };